import http from "../helpers/httpCommon";

class PingService {
    ping() {
        return http().post("/ping", {});
    }
}

export default new PingService();
